import React, {useEffect, useState} from "react";
import Breadcrumbs from "../../../components/breadcrumbs";
import {useDispatch, useSelector} from "react-redux";
import {useHistory} from "react-router-dom";
import Button from "../../../components/button";
import Modal from "../../../components/modal";
import Input from "../../../components/input";
import TextArea from "../../../components/text-area";
import LoadingSpinner from '../../../components/loading-spinner';
import {ToastContainer, toast} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import SelectInput from "../../../components/select";
import { clear_assist_control, searchConsultations, UPDATE_ASSIST_CONTROL, updateAssistControl } from "../../../redux/assist_control";
import { searchUserTeamsActivity } from "../../../redux/activities";
import {DirectionsRenderer, GoogleMap, useJsApiLoader} from "@react-google-maps/api";
import {KEY_MAPS} from "../../../config";
import Footer from "../../../components/footer";

const ConsultationsAssistControl = (props) => {
    let history = useHistory();
    let dispatch = useDispatch();

    var date = new Date();
    
    const {token} = useSelector((state) => state.users_module.login.data) || null;
    const _update_assist_control = useSelector((state) => state.assist_control_module._update_assist_control);

    const [id, setId] = useState(0);
    const [id_usuario, setIdUsuario] = useState(0);
    const [users, setUsers] = useState([]);
    const [dateStart, setDateStart] = useState(new Date(date.getFullYear(), date.getMonth(), 1).toLocaleDateString('en-CA'));
    const [dateEnd, setDateEnd] = useState(new Date(date.getFullYear(), date.getMonth() + 1, 0).toLocaleDateString('en-CA'));
    const [isLoading, setIsLoading] = useState(false);
    const [comentario, setComentario] = useState('');
    const [datas, setDatas] = useState(false);
    const [modal, setModal] = useState(false);
    const [modalMaps, setModalMaps] = useState(false);
    const [locations, setLocations] = useState([]);
    const [permisos, setPermisos] = useState([]);
    useEffect(() => {
        if (props) {
            const array = Object.values(props);
            setPermisos(array);
        }
    }, [props]);

    useEffect(() => {
        getUserTeamsActivity(token);
        // eslint-disable-next-line
    }, [token]);

    async function getUserTeamsActivity(token) {
        setIsLoading(true);
        let params = '';
        try {
            const response = await searchUserTeamsActivity(token, params);
            if (response && response.data && response.data.datos) {
                setUsers(response.data.datos);
            }
            setIsLoading(false);
        } catch (e) {
           setIsLoading(false);
        }
    }

    async function get_assist_control_stores() {
        setIsLoading(true);
        if (id_usuario === 0) {
            toast.error("Debe seleccionar un usuario", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (dateStart === "") {
            toast.error("Debe ingresar la fecha de inicio", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (dateEnd === "") {
            toast.error("Debe ingresar la fecha final", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        // eslint-disable-next-line
        let params = "?id_usuario=" + id_usuario + '&&fecha_inicio=' + dateStart + '&&fecha_final=' + dateEnd;
        try {
            const response = await searchConsultations(token, params);
            if (response && response.data && response.data.datos) {
                setDatas(response.data.datos);
                setIsLoading(false);
            }
        } catch (e) {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        if (_update_assist_control.status === 200) {
            toast.success("Actualizado correctamente", {position: toast.POSITION.TOP_RIGHT});
            dispatch(clear_assist_control(UPDATE_ASSIST_CONTROL));
            get_assist_control_stores();
            setIsLoading(false);
            setModal(false);
            setId(0);
            setComentario('');
        } else if (_update_assist_control.status !== 0) {
            dispatch(clear_assist_control(UPDATE_ASSIST_CONTROL));
            toast.error(_update_assist_control.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
        // eslint-disable-next-line
    }, [_update_assist_control, dispatch, history, token]);


    const handleSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (comentario === "") {
            toast.error("Debe ingresar un comentario", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        dispatch(updateAssistControl(token, id, {'comentario': comentario}));
    };

    const {isLoaded} = useJsApiLoader({
        id: "google-map-script",
        googleMapsApiKey: KEY_MAPS,
    });

    const [directionsResponse, setDirectionsResponse] = useState(null);

    let directionsService;
    const calculateRoute = (ubications) => {
        directionsService = new window.google.maps.DirectionsService();
        const routesCopy = ubications.map(route => {
            return {
                location: {lat: parseFloat(route.latitud), lng: parseFloat(route.longitud)},
                stopover: true
            };
        });

        const origin =
            routesCopy.length === 1
                ? new window.google.maps.LatLng(
                    routesCopy[0].location.lat,
                    routesCopy[0].location.lng
                )
                : routesCopy.shift().location;
        const destination =
            routesCopy.length === 1
                ? new window.google.maps.LatLng(
                    routesCopy[0].location.lat,
                    routesCopy[0].location.lng
                )
                : routesCopy.pop().location;
        const waypoints = routesCopy;

        //call getDirection function
        getDirection(origin, destination, waypoints);
    };

    const getDirection = (origin, destination, waypoints) => {
        waypoints.length >= 1
            ? directionsService.route(
                {
                    origin: origin,
                    destination: destination,
                    travelMode: window.google.maps.TravelMode.DRIVING,
                    waypoints: waypoints
                },
                (result, status) => {
                    if (status === window.google.maps.DirectionsStatus.OK) {
                        setDirectionsResponse(result)
                    } else {
                        console.log('error fetching directions1455 ' + result);
                    }
                }
            )
            : directionsService.route(
                {
                    origin: origin,
                    destination: destination,
                    travelMode: window.google.maps.TravelMode.DRIVING
                },
                (result, status) => {
                    if (status === window.google.maps.DirectionsStatus.OK) {
                        setDirectionsResponse(result)
                    } else {
                        console.log('error fetching directions ' + result);
                    }
                }
            );
    };

    function clearRoute() {
        setDirectionsResponse(null);
    }

    return (
        <div className="app-content content">
            <div className="content-overlay"/>

            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 mt-1">
                        <Breadcrumbs
                            title="Control de asistencia"
                            items={[{label: "Consulta", link: "/consultas/control-asistencia"}]}
                        />
                    </div>
                </div>
                <div className="content-body">
                    <div><ToastContainer/></div>
                    {isLoading && <LoadingSpinner/>}
                    <div className="card">
                        <div className="card-content">
                            <div className="card-body">
                            <div className="row mt-1">
                                    <div className="border_card mb-1 col-12">
                                        <p className="ml-1" style={{marginTop: 10, fontSize: 18, color: '#727E8C'}}>Consulta de asistencia y marcaciones</p>
                                    </div>
                                    <div className="border_card col-12">
                                        <div className="row">
                                            <div className="col-md-3 col-sm-6 col-12">
                                                <div className="form-group">
                                                    <label>Usuario</label>
                                                    <SelectInput
                                                        label="Usuario"
                                                        name="id_usuario"
                                                        value={id_usuario}
                                                        onChange={(e) => setIdUsuario(parseInt(e.target.value))}
                                                        options={users ? users.map((item) => ({
                                                            name: item.nombres,
                                                            id: item.id,
                                                        })) : []}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-3 col-sm-6 col-12">
                                                <Input
                                                    name="dateStart"
                                                    label="Desde"
                                                    type="date"
                                                    value={dateStart}
                                                    onChange={(e) => {setDateStart(e.target.value)}}
                                                />
                                            </div>
                                            <div className="col-md-3 col-sm-6 col-12">
                                                <Input
                                                    name="dateEnd"
                                                    label="Hasta"
                                                    type="date"
                                                    value={dateEnd}
                                                    onChange={(e) => {setDateEnd(e.target.value)}}
                                                />
                                            </div>
                                            <div className="col-md-3 col-sm-6 col-12 text-center mt-2">
                                                <Button type="button" text="Buscar" theme="calendar" onClick={() => {
                                                    get_assist_control_stores();
                                                }}/>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        {(datas) &&
                                            datas.map((x) => (
                                                <div className="row mt-1 p-1 border-card">
                                                    <div className="col-md-8 col-12">
                                                        <div className="d-flex">
                                                            <div className="ml-1 pt-1">
                                                                <span className="texto_16 pt-1">{x.fecha}</span>
                                                            </div>
                                                            <div className="ml-2">
                                                                <span className="texto_14">Inicio de jornada</span><br/>
                                                                <strong className="texto_16">{x.hora_inicio}</strong>
                                                            </div>
                                                            <div className="ml-2">
                                                                <span className="texto_14">Fin de jornada</span><br/>
                                                                <strong className="texto_16">{x.hora_fin}</strong>
                                                            </div>
                                                        </div>
                                                        <div className="ml-1 mt-1">
                                                            <span className="texto_14">Comentario: {x.comentario}</span>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4 col-12 text-right mt-1">
                                                        {
                                                            permisos.filter(x => x.codigo === 'change_assistcontrol').length > 0 &&
                                                            <Button style={{marginRight: 10}} type="button" text="Agregar comentaruo" theme="calendar" onClick={() => {
                                                                setId(x.id);
                                                                setComentario(x.comentario);
                                                                setModal(true);
                                                            }}/>
                                                        }
                                                        <Button type="button" text="Ver mapa" theme="calendar" onClick={() => {
                                                            if (x.ubicaciones.length > 0) {
                                                                setLocations(x.ubicaciones);
                                                                calculateRoute(x.ubicaciones);
                                                                // calculateLocations(x.ubicaciones);
                                                            }
                                                            setModalMaps(true);
                                                        }}/>
                                                    </div>
                                                    <div className="col-12 mt-2">
                                                        <table className="table table-bordered">
                                                            <thead>
                                                                <tr>
                                                                    <th className="text-center">Tienda</th>
                                                                    <th className="text-center">Hora de inicio</th>
                                                                    <th className="text-center">Hora de salida</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {x.tiendas.map((t) => (
                                                                    <tr>
                                                                        <td>{t.tienda}</td>
                                                                        <td>{t.hora_entrada}</td>
                                                                        <td>{t.hora_salida}</td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            ))
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal className="modal-main div-modal" show={modal}>
                <form onSubmit={handleSubmit}>
                    {isLoading && <LoadingSpinner/>}
                    <div className="card-body">
                        <h5 className="titulo_modal type_text mb-2">Agregar Comentario</h5>
                        <div className="form-group">
                            <TextArea
                                id="comentario"
                                name="comentario"
                                label="Comentario"
                                placeholder=""
                                value={comentario}
                                onChange={(e) => {setComentario(e.target.value)}}
                                rows={4}
                            />
                        </div>
                    </div>
                    <div className="card-footer text-center">
                        <button disabled={isLoading} onClick={() => {
                        }} className={`btn btn-calendar mb-1 button_div`}>Guardar
                        </button>
                        <button type="button" onClick={() => {
                            setModal(false);
                        }} className={`btn btn-outline-calendar button_div`}>Cancelar
                        </button>
                    </div>
                </form>
            </Modal>
            <Modal className="modal-main div-modal" show={modalMaps}>
                <div className="card-body">
                    <h5 className="titulo_modal type_text mb-2">Marcaciones mapa</h5>
                    <div>
                        {(isLoaded && locations.length > 0) &&
                            <GoogleMap
                            center={{
                                lat: parseFloat(locations[0].latitud),
                                lng: parseFloat(locations[0].longitud)
                            }}
                            zoom={11}
                            options={{streetViewControl: false}}
                            mapContainerStyle={{width: "100%", height: "50vh"}}
                        >
                            {directionsResponse && (
                                <DirectionsRenderer directions={directionsResponse}/>
                            )}
                        </GoogleMap>
                        }
                    </div>
                </div>
                <div className="card-footer text-center">
                    <button type="button" onClick={() => {
                        setModalMaps(false);
                        clearRoute();
                    }} className={`btn btn-calendar button_div`}>Salir
                    </button>
                </div>
            </Modal>
            <Footer/>
        </div>
    );
};

export default ConsultationsAssistControl;
